import styled from "styled-components";

interface CounterProps {
  zeroCounter?: boolean;
  isInfinity?: boolean;
}

export const CounterBodyStyled = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 21px;
`;

export const CounterStopsStyled = styled.div<CounterProps>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: "Readex Pro", sans-serif;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  line-height: 19.6px;
  word-wrap: break-word;
  color: ${(props) => (props.zeroCounter ? "#a4a4a4" : "#606060")};
  z-index: 1;
`;

export const CounterLoopsStyled = styled.div<CounterProps>`
  font-family: "Readex Pro", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 19.6px;
  word-wrap: break-word;
  text-align: ${(props) => (props.isInfinity ? "start" : "center")};
  color: ${(props) => (props.zeroCounter ? "#a4a4a4" : "#606060")};
`;

export const DividerStopsCountersStyled = styled.div`
  font-family: "Readex Pro", sans-serif;
  font-weight: 300;
  font-size: 14px;
  line-height: 19.6px;
  word-wrap: break-word;
  color: #a4a4a4;
`;

export const DividerLoopsCountersStyled = styled.div`
  padding: 0 4px;
`;
